import { Component } from "react";
import { ErrorBoundariesRepository } from "core/repository";
import { mapStackTrace } from "sourcemapped-stacktrace";
import { Base2Presenter } from "core/presenter";

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo
    });
    mapStackTrace(error.stack || "", mappedStack => {
      const errorMessage = `[PAINEL] ${window.location.href} \`${
        error.message
      }\`\n\`\`\`${mappedStack.join("\n")}\`\`\``;
      ErrorBoundariesRepository.alert(errorMessage);
    });
  }

  errorBody(children) {
    Base2Presenter.router.stateService.go("app.unexpected-error", {}, {});
    return children;
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return hasError ? this.errorBody(children) : children;
  }
}



// WEBPACK FOOTER //
// ./src/components/support/error-boundary/index.jsx